import { useMemo } from 'react';
import { ItemInfoDto } from '../../../services/Item/itemService.dto';
import { itemService } from '../../../services/Item/itemService';
import { useBackendData } from '../../../services/useBackendData';
import { auctionService } from '../../../services/Auction/auctionService';
import { AuctionDto, BidDto } from '../../../services/Auction/auctionService.dto';

type BidsSorting = 'asc' | 'desc';

export const useItemDetails = (itemId?: number, itemData?: ItemInfoDto) => {
  const {
    data: item,
    isLoading: isItemLoading,
    refetch: refetchItem,
  } = useBackendData({
    queryKey: ['item', itemId],
    queryFn: () => itemService.fetchSingleItem(itemId!),
    enabled: !itemData && !!itemId,
    initialData: itemData,
  });

  const {
    data: auction,
    isLoading: isAuctionLoading,
    refetch: refetchAuction,
  } = useBackendData({
    queryKey: ['auction', item?.id],
    queryFn: () => auctionService.fetchAuctionDetails(item!.id).then(res => sortBids(res.data, 'desc')),
    enabled: !!item && item.sellingMethod === 'AUCTION',
  });

  const info = useMemo(() => (!!item ? `${item.title} (#${item.id})` : ''), [item]);
  const isLoading = isItemLoading || isAuctionLoading;

  return { item, auction, isLoading, info, refetchAuction, refetchItem };
};

export const sortBids = (content: AuctionDto, bidsSorting: BidsSorting): AuctionDto => {
  const sortedBids = content.bids.sort((bid1, bid2) =>
    bidsSorting === 'asc' ? compareBids(bid1, bid2) : compareBids(bid2, bid1)
  );

  return { ...content, bids: sortedBids };
};

const compareBids = (bid1: BidDto, bid2: BidDto) => bid1.created.localeCompare(bid2.created);
